import React from 'react';
import './CulturesMapTab.style.scss';
import { useTranslation } from 'react-i18next';

const TotalMapTab = ({ totalSurface, fromProduction = false }) => {
  const { t } = useTranslation();
  return (
    <div
      className={
        fromProduction ? 'cultures-map-tab-surface sticky-table' : 'cultures-map-tab-surface'
      }
    >
      <p>
        <span>{t('simulation.result.pdf.cropMargin.surfaceSAU')}</span>
        <span>{Math.round(totalSurface * 100) / 100} ha</span>
      </p>
    </div>
  );
};

export default TotalMapTab;
